/**
 * Admin Layout Component
 * Part of TASK-334: Frontend Admin Panel
 *
 * Main layout wrapper for admin panel pages with header and sidebar.
 */

import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAccount } from '../../contexts/AccountContext';
import AdminHeader from '../../components/admin/AdminHeader';
import AdminSidebar from '../../components/admin/AdminSidebar';

const AdminLayout: React.FC = () => {
  const { isAdmin, isAuthenticated } = useAccount();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Redirect non-admin users to dashboard
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <AdminHeader />

      {/* Main content area with sidebar */}
      <div className="flex-1 flex">
        {/* Sidebar */}
        <AdminSidebar
          collapsed={sidebarCollapsed}
          onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        />

        {/* Page content */}
        <main className="flex-1 overflow-auto">
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
